/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import {
	getAuth,
	onAuthStateChanged,
	signOut,
	signInWithEmailAndPassword,
	sendPasswordResetEmail,
	fetchSignInMethodsForEmail,
	createUserWithEmailAndPassword
} from "firebase/auth";

export default class AuthWrapper {

	auth

	constructor(firebaseWrapper) {
		this.auth = getAuth(firebaseWrapper.firebaseApp);
	}

	onAuthStateChanged(callback, errorCallback){
		return onAuthStateChanged(this.auth, callback, errorCallback);
	}
	async signOut(){
		return signOut(this.auth);
	}

	async signInWithEmailAndPassword(email, password){
		return signInWithEmailAndPassword(this.auth, email, password)
	}

	async sendPasswordResetEmail(email){
		return sendPasswordResetEmail(this.auth, email)
	}

	async fetchSignInMethodsForEmail(email){
		return fetchSignInMethodsForEmail(this.auth, email)
	}

	async createUserWithEmailAndPassword(email, password){
		return createUserWithEmailAndPassword(this.auth, email, password)
	}



	get currentUser(){
		return this.auth.currentUser
	}
}
